import React from 'react';
import { pulseStyle } from 'shared/styles';
import styled, { css } from 'styled-components';

export type SkeletonVariant = 'text' | 'circular' | 'rectangular';

interface SkeletonProps {
    className?: string;
    width?: number;
    height?: number;
    variant?: SkeletonVariant;
    duration?: number;
}

const Skeleton = (props: SkeletonProps) => {
    const { className, width, height, variant = 'text', duration } = props;

    return (
        <Root className={ className }
            $width={ width }
            $height={ height }
            $variant={ variant }
            $duration={ duration }
        />
    );
};

export default Skeleton;

const textVariantStyle = css<{ $width?: number }>`
    border-radius: ${ ({ theme }) => theme.borderRadius };
    height: ${ ({ theme }) => theme.size.size_15 };
    width: ${ ({ $width }) => ($width === undefined ? '100%' : `${ $width }px`) };
`;

const dimensionStyle = css<{ $width?: number, $height?: number }>`
    width: ${ ({ $width }) => ($width === undefined ? '100%' : `${ $width }px`) };
    height: ${ ({ $height }) => ($height === undefined ? '100%' : `${ $height }px`) };
`;

const circularVariantStyle = css<{ $width?: number, $height?: number }>`
    border-radius: 50%;

    ${ dimensionStyle }
`;

const rectangularVariantStyle = css<{ $width?: number, $height?: number }>`
    ${ dimensionStyle }
`;

const Root = styled.div<{ $width?: number; $height?: number; $variant: SkeletonVariant; $duration?: number }>`
    ${ ({ $variant }) => $variant === 'text' && textVariantStyle }
    ${ ({ $variant }) => $variant === 'circular' && circularVariantStyle }
    ${ ({ $variant }) => $variant === 'rectangular' && rectangularVariantStyle }

    ${ pulseStyle }
`;
